<header class="go-page-title">
  <h1 class="go-heading-1">Virtual Scroll</h1>
</header>

<div class="go-container">
  <go-card
    [showHeader]="false"
    class="go-column go-column--100">
    <div go-card-content>
      <p class="go-body-copy">
        For any implementation of infinite/virtual scrolling, we use <strong>Angular Material's CDK.</strong>
      </p>
      
      <p class="go-body-copy go-body-copy--no-margin">
        Please refer to 
        <strong>
          <a
            class="go-link"
            href="https://material.angular.io/cdk/scrolling/overview">
            its documentation
          </a>
        </strong>
        for usage, API, and examples.
      </p>
    </div>
  </go-card>

</div>
